import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { api } from "../lib/api";
import { toast } from "sonner";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("hello@islandsdaily.com");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const res = await api.post("/admin/login", { email, password });
      localStorage.setItem("ir_token", res.data.token);
      toast.success("Welcome back");
      nav("/admin/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-4">
      <form
        onSubmit={submit}
        className="w-full max-w-md card-soft p-8 border border-[#E5E5E5]"
        data-testid="admin-login-form"
      >
        <Link
          to="/"
          className="font-serif-display text-2xl mb-1 inline-block"
        >
          <span className="text-[#1A1A1A]">Islands</span>
          <span className="text-[#0AADA0]">Daily</span>
        </Link>
        <div className="flex items-center gap-2 mb-6 text-[#6B7280]">
          <Lock size={14} />
          <span className="text-[11px] uppercase tracking-wider">
            Admin Console
          </span>
        </div>
        <div className="space-y-4">
          <div>
            <label className="block text-[11px] uppercase tracking-wider text-[#6B7280] mb-2">
              Email
            </label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-[#FAFAFA] rounded-lg px-4 py-3 text-[#1A1A1A] focus:bg-white focus:ring-2 focus:ring-[#0AADA0] focus:outline-none"
              data-testid="admin-email-input"
            />
          </div>
          <div>
            <label className="block text-[11px] uppercase tracking-wider text-[#6B7280] mb-2">
              Password
            </label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-[#FAFAFA] rounded-lg px-4 py-3 text-[#1A1A1A] focus:bg-white focus:ring-2 focus:ring-[#0AADA0] focus:outline-none"
              data-testid="admin-password-input"
            />
          </div>
          <button
            type="submit"
            disabled={busy}
            className="w-full py-3 rounded-full bg-[#E63946] hover:bg-[#cf2f3c] text-white transition-colors disabled:opacity-60"
            data-testid="admin-login-submit"
          >
            {busy ? "Signing in..." : "Sign in"}
          </button>
        </div>
      </form>
    </div>
  );
}
